import { ChannelSearchFunctionParams, DefaultStreamChatGenerics } from 'stream-chat-react';

import { ChannelFilters, StreamChat } from 'stream-chat';

import getChannelsWithName from './getChannelsWithName';

const customSearchFunction = async (
	props: ChannelSearchFunctionParams,
	event: { target: { value: string } },
	client: StreamChat,
	currentUserId: string,
	filters: ChannelFilters<DefaultStreamChatGenerics>,
) => {
	const { setResults, setSearching, setQuery } = props;
	const { value } = event.target;

	setSearching(true);
	setQuery(value);

	// Query users matching the search value
	const members = await client.queryUsers(
		{
			$or: [{ id: { $autocomplete: String(value) } }, { name: { $autocomplete: String(value) } }],
			id: { $ne: `${currentUserId}` },
		},
		{ last_active: -1 },
		{ limit: 100 },
	);

	const memberIds = (members?.users || []).map((user) => user.id);

	// Create channel filters based on search value and user IDs
	const channelFilters = {
		$and: [
			{ ...filters },
			{
				$or: [{ name: { $autocomplete: String(value) } }, { members: { $in: memberIds } }],
			},
		],
	};

	// Query channels based on filters
	// @ts-expect-error
	const channels = await client.queryChannels(channelFilters);

	// Add fallback names to channels
	const channelsWithName = getChannelsWithName(channels, Number(currentUserId));

	// Update results and stop searching
	// @ts-ignore
	setResults(channelsWithName);
	setSearching(false);
};

export default customSearchFunction;
